export default __webpack_public_path__ + "605ba6751fbc6eac85ca6b62c8a427f9.png";